import { Link } from "react-router-dom";
import "./about.css";

const About = () => {
  return (
    <>
      <div className="aboutContainer">
        <div className="fadeLeft" style={{ animationDelay: "200ms" }}>
          <div className="aboutPara">
            Hi! I'm <span className="aboutLink">Sonu Bardai</span>, and I'm
            passionate about building innovative projects that address
            real-world problems. With my skills as a{" "}
            <span className="aboutEmph">Full Stack Developer</span> and a{" "}
            <span className="aboutEmph">Digital Illustrator</span>, I bring a
            unique combination of technical expertise and creativity to
            everything I do.
          </div>
        </div>
        <div className="fadeRight">
          <h2 className="aboutSide">About Me</h2>
          <div className="aboutPara">
            As a problem solver at heart, I have a strong urge to learn new
            technologies and use them to build cool and unique projects. I'm
            motivated to expand and advance my skill set through innovation and
            collaboration, and I take pride in building all my{" "}
            <Link to="/projects" className="aboutLink">
              projects
            </Link>{" "}
            with a focus on security, scalability, and code readability.
          </div>
          <br />
          <div className="aboutPara">
            In addition to creating robust, efficient, and effective code in the
            backend, my skills as a Digital Illustrator allow me to be{" "}
            <span className="aboutEmph">creative</span> when it comes to
            building beautiful, modern, and user-friendly User Interfaces. I
            love combining my technical and artistic abilities to create
            projects that are both functional and visually stunning.
          </div>
        </div>

        <hr className="aboutLine" />

        <div className="fadeRight">
          <h2 className="aboutSide">Experience</h2>
          <div className="aboutPara">
            I'm a passionate software engineer with a thirst for knowledge and a
            love for meeting new people. I'm currently working as a{" "}
            <span className="aboutEmph">Software Engineer</span> at{" "}
            <span className="aboutEmph">Navtech Pvt Ltd</span>, where I've had the
            incredible opportunity to work directly with a talented US-based
            client development team to build and maintain an application
            tracking system. I've gained invaluable technical expertise in{" "}
            <span className="aboutEmph">
              Python, TypeScript, Docker, Django, React JS, Rust, and more
            </span>
            .
          </div>
          <br />
          <div className="aboutPara">
            In my time at Navtech, I've developed a robust job apply flow that
            resulted in an astounding increase of 80-100k job applicants every
            month. I also had the privilege of working with a small but mighty
            development team to build a complete ETL data pipeline. I've also
            worked on a complete website re-branding effort, worked on migrating
            a large chunk of the legacy PHP code-base to Python, and assisted
            with developing various dev tools in Rust.
          </div>
          <br />
          <div className="aboutPara">
            Prior to joining Navtech, I interned at{" "}
            <span className="aboutEmph">Microsoft</span> as an{" "}
            <span className="aboutEmph">Azure Development Intern</span>. During
            my internships, I studied the Azure cloud platform and worked on an
            array of Azure cloud services, collaborated in a team to develop and
            debug Full-Stack projects. I also interned at{" "}
            <span className="aboutEmph">INTS Co.</span> as a{" "}
            <span className="aboutEmph">Full-Stack Developer Intern</span> and
            received training on building and troubleshooting React frontend
            applications and developing REST-ful backend APIs.
          </div>
          <br />
          <div className="aboutPara">
            In addition to my professional experience, I'm also the proud
            creator and maintainer of <span className="aboutEmph">Lockbox</span>
            , an open-source password generator and manager built in Rust. I'm
            also an active contributor to the Alacritty project, a
            cross-platform OpenGL terminal emulator built in Rust.
          </div>
          <br />
          <div className="aboutPara">
            When I'm not coding, you can find me working on{" "}
            <span className="aboutEmph">digital art</span>. Checkout some of my{" "}
            <Link to={"/art"} className="aboutLink">
              digital illustrations
            </Link>
            . I have worked on various freelancing projects on Fiverr in the
            past. I love sharing my knowledge on my{" "}
            <a
              href="https://www.youtube.com/@sonubardai"
              target="_blank"
              rel="noreferrer"
              className="aboutLink"
            >
              YouTube channel
            </a>{" "}
            and <span className="aboutEmph">tech blogs</span> on{" "}
            <a
              href="https://dev.to/sonubardai"
              target="_blank"
              rel="noreferrer"
              className="aboutLink"
            >
              Dev.to
            </a>{" "}
            and{" "}
            <a
              href="https://sonubardai.hashnode.dev/"
              target="_blank"
              rel="noreferrer"
              className="aboutLink"
            >
              Hashnode
            </a>
            . I'm passionate about programming languages, DevOps concepts, and
            emerging technologies. I'm always eager to learn more and expand my
            skillset.
          </div>
          <br />
        </div>

        <hr className="aboutLine" />

        <div className="fadeUp" style={{ animationDelay: "400ms" }}>
          <h2 className="aboutSide">How I Began Software Development</h2>
          <div className="aboutPara">
            My journey into the world of software development began when I
            enrolled in a Computer Science Engineering program. I was initially
            drawn to the course because of my fascination with programming, but
            as I delved deeper into my studies, my love for it grew even
            stronger. I started out by participating in competitive programming
            and solving challenging coding problems that pushed me to my limits.
          </div>
          <div className="aboutPara">
            Eventually, though, I found myself wanting more than just the
            satisfaction of solving niche problems using complicated algorithms
            and convoluted data structures. I wanted to use my programming
            skills to{" "}
            <span className="aboutEmph">build real-world solutions</span>.
            That's when I embarked on my journey into the world of{" "}
            <span>Full-stack development</span>.
          </div>
          <br />
          <div className="aboutPara">
            I began by teaching myself the basics of front-end development
            (HTML, CSS, JS), and then moved on to learning Python Flask for the
            backend. As a <span className="aboutEmph">fast learner</span> who
            prefers hands-on learning, I found that building projects was the
            best way for me to acquire new skills and knowledge. This approach
            laid a solid foundation for my web development journey.
          </div>
          <br />
          <div className="aboutPara">
            Fast forward to today, and I have had the privilege of working with
            incredible people at various companies, contributing to open source
            projects, and building my own open source projects. I have built
            projects using a variety of Javascript and Python frameworks,
            including ReactJS, Django, and NodeJS, and have expanded my skillset
            by learning new programming languages like Rust and Golang. My
            passion for learning and building has only grown stronger with each
            new project, challenge, and collaboration.
          </div>
        </div>

        <hr className="aboutLine" />

        <div className="fadeDown" style={{ animationDelay: "600ms" }}>
          <h2 className="aboutSide">My Motto</h2>
          <div className="aboutPara">
            My motto is simple: never stop learning. As a firm believer in the{" "}
            <span className="aboutEmph">never-ending process of learning</span>,
            I thoroughly enjoy acquiring new knowledge and skills. A large
            portion of my full-stack development expertise is{" "}
            <span className="aboutEmph">self-taught</span>, and I take great
            pride in the skills that I have acquired through my own hard work
            and determination.
          </div>
          <div className="aboutPara">
            As a <span className="aboutEmph">self-motivated</span> individual, I
            thrive on taking on new challenges and learning new technologies to
            solve problems. My passion for building innovative solutions drives
            me to constantly push myself to be better and achieve more.
          </div>
        </div>

        <hr className="aboutLine" />

        <div className="aboutPara">
          Thank you for taking the time to learn more about me! I'm excited to
          continue growing as a software engineer and meeting amazing people
          along the way. 😊
        </div>
      </div>
    </>
  );
};

export default About;
